import { styled } from '@mui/material/styles';
import isPropValid from '@emotion/is-prop-valid';
import { headerFontFamily, neutral, primaryBlack } from '@style/variables';
import { BackgroundColor } from './_enums';

const backgroundColors = {
  [BackgroundColor.Black]: primaryBlack,
  [BackgroundColor.Dark]: neutral[900],
  [BackgroundColor.Light]: 'var(--tra-color-surface-200)',
};

export const ProductAccordionContainer = styled('div', {
  shouldForwardProp: isPropValid,
})<{ backgroundTheme: BackgroundColor }>`
  display: grid;
  background-color: ${(props) => backgroundColors[props.backgroundTheme]};
  padding: 80px 0;
  grid-template-rows: min-content;
  position: relative;

  ${(props) => props.theme.breakpoints.up('md')} {
    grid-template-columns: 1fr 32%;
    grid-template-rows: 1fr;
    padding: 110px 0;
  }

  ${(props) => props.theme.breakpoints.up('xl')} {
    grid-template-columns: 1fr 30%;
    padding: 145px 0;
  }
`;

export const OverlayWrapper = styled('div')`
  aspect-ratio: 16 / 9;
  position: sticky;
  top: 100px;
  ${(props) => props.theme.breakpoints.up('md')} {
    aspect-ratio: 5 / 4;
  }
`;

export const DropdownImageWrap = styled('div')`
  position: relative;
  aspect-ratio: 16 / 9;
`;

export const ImageWrapper = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;

  ${(props) => props.theme.breakpoints.up('md')} {
    margin-top: -25%;
  }
`;

export const AccordionContainer = styled('div')`
  padding: 0 24px;

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: 0 40px 0 0;
  }

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: 0 80px 0 0;
  }
`;

export const ProductImageContainer = styled('div')`
  position: relative;

  .tout-content {
    margin-left: 24px;

    ${(props) => props.theme.breakpoints.up('md')} {
      z-index: 1;
      margin-left: 40px;
    }

    ${(props) => props.theme.breakpoints.up('md')} {
      margin-left: 80px;
    }

    .lilHeading,
    .heading {
      font-size: clamp(5rem, 3.6364rem + 6.0606vw, 10rem);
      line-height: 0.8;
    }

    .heading {
      font-family: ${headerFontFamily};
    }
  }

  .product-overlay {
    top: 0;
    width: 100%;
    height: 100%;

    ${(props) => props.theme.breakpoints.up('md')} {
      position: absolute;
      width: 100%;
    }
  }
`;

export const VideoContainer = styled('div')`
  margin-top: 16px;
  width: 100%;

  ${(props) => props.theme.breakpoints.up('md')} {
    margin-top: 24px;
  }

  .extra-large-container {
    height: 100%;
    aspect-ratio: 1;

    video,
    img {
      width: 100%;
    }
  }
`;
